module.exports = __webpack_public_path__ + "static/media/file-contract.bb22bca6.svg";